import { configureStore } from "@reduxjs/toolkit";
import conversationsSlice from "./conversationsSlice";
export const store = configureStore({
  reducer: {
    conversations: conversationsSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
